/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
require('../plugins');

require('dropzone');
import Splide from '@splidejs/splide';

// import Vue from 'vue';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });


if($('.splide-testimonial').length) {
    // SPLIDE JS
    let sliderConfig = {
        type: 'loop',
        perPage: 1,
        pagination: true,
        arrows: false,
        perMove: 1,
        slideFocus: true,
        autoplay: true,
        interval: 4000,
        focus: 'center',
        autoScroll: {
            speed: 3,
        },
    }

    new Splide('.splide-testimonial', sliderConfig).mount();
}

console.log(`
    INILAH BARISAN KITA
    ====================

    Inilah barisan kita,
    Yang ikhlas berjuang.
    Siap sedia berkorban,
    Untuk ibu pertiwi!

    Sebelum kita berjaya,
    Jangan harap kami pulang!
    Inilah sumpah pendekar kita,
    Menuju medan bakti!

    Andai kata kami gugur semua,
    Taburlah bunga di atas pusara.
    Kami mohon doa,
    Malaysia berjaya!

    Semboyan telah berbunyi,
    Menuju medan bakti!

    SELAMAT HARI KEMERDEKAAN KALI KE-65 TAHUN 2022!

    ███╗   ███╗ █████╗ ██╗      █████╗ ██╗   ██╗███████╗██╗ █████╗
    ████╗ ████║██╔══██╗██║     ██╔══██╗╚██╗ ██╔╝██╔════╝██║██╔══██╗
    ██╔████╔██║███████║██║     ███████║ ╚████╔╝ ███████╗██║███████║
    ██║╚██╔╝██║██╔══██║██║     ██╔══██║  ╚██╔╝  ╚════██║██║██╔══██║
    ██║ ╚═╝ ██║██║  ██║███████╗██║  ██║   ██║   ███████║██║██║  ██║
    ╚═╝     ╚═╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝╚═╝╚═╝  ╚═╝

    Nota:
    Jika anda terjumpa bug/security issue di laman ini
    Boleh hubungi developer kami di nurul@ifcontech.com
`)

if($('.custom-dropzone').length) {
    // DROPZONE
    let dropzoneFile = [];
    var formData = new FormData();

    Dropzone.autoDiscover = false;

    $('.custom-dropzone').each(function(index) {
        dropzoneFile[index] = 0;
        let idName = $(this).attr('id');
        let id = '#' + idName;
        let dropzone = document.querySelector(id);

        var previewNode = dropzone.querySelector(".dropzone-item");
        previewNode.id = "";
        var previewTemplate = previewNode.parentNode.innerHTML;
        previewNode.parentNode.removeChild(previewNode);

        $(dropzone).dropzone({
            url: "/api/dropzone/",
            maxFiles: 1,
            autoProcessQueue: false,
            autoQueue: true,
            acceptedFiles: ".pdf, .doc, .docx, .jpeg, .jpg, .png",
            maxFilesize: 25,
            init: function() {

                this.on("addedfile", function(file) {
                    if (this.files.length > 1) {
                        this.removeFile(this.files[0]);
                    }

                    if (this.files.length > 0) {
                        $(`#parsley-id-${index}`).addClass('hidden');
                        $(`#maxsize-id-${index}`).addClass('hidden');
                    }

                    // VALIDATION ON NEXT BUTTON
                    dropzoneFile[index] = this.files.length;
                    // var reader = new FileReader();
                    // reader.onload = isLoaded;
                    // reader.readAsDataURL(this.files[0]);

                    formData.append('resume', file);

                    // function isLoaded(e) {
                    //     var cv = '<input type="hidden" name="resume" value="' + e.target
                    //         .result + '" class="hidden">'
                    //     let fileExt = e.target.result.split(';')[0].split('/');
                    //     fileType = fileExt[1];
                    //     $("#cv").append(cv);
                    // }
                });

                this.on('complete', function(file) {
                    if (file.xhr.readyState === 4) {
                        $('<input>').attr({
                            type: 'hidden',
                            id: 'file_' + file.upload.uuid,
                            name: 'proof_of_' + idName + '[]',
                            value: file.xhr.responseText
                        }).appendTo('#fileInput');
                        console.log(idName);
                    }
                });

                this.on("removedfile", function(file) {
                    if (this.files.length == 0) {
                        $(`#parsley-id-${index}`).removeClass('hidden');
                    }

                    $('#file_' + file.upload.uuid).remove();

                    // VALIDATION ON NEXT BUTTON
                    dropzoneFile[index] = this.files.length;
                });

                this.on('error', function(file, errorMessage, xhr) {
                    console.log(errorMessage);
                    this.removeFile(file)
                    let errors = errorMessage.errors
                    if (errors.hasOwnProperty('file')) {
                        Swal.fire({
                            title: 'Error!',
                            html: errors.file[0],
                            icon: 'error',
                            confirmButtonColor: '#2db673',
                        });
                    } else {
                        Swal.fire({
                            title: 'Error!',
                            html: errorMessage,
                            icon: 'error',
                            confirmButtonColor: '#2db673',
                        });
                    }
                });

            },
            previewTemplate: previewTemplate,
            previewsContainer: id + " .dropzone-items",
        })
    });

    $('#submitForm').on('submit', async function(e) {
        e.preventDefault();

        await grecaptcha.execute()
            .then(function(token) {
                formData.append('g-recaptcha-response', token)
            });


        // grecaptcha.execute().then((token) => {
        //     console.log(token)
        //     if (grecaptcha.getResponse().length > 0) {
        //         let val = $('input[name="position"]:checked').val();
        //         formData.append('position', val);
        //         formData.append('g-recaptcha-response', $('#g-recaptcha-response').val())
        //         if (!val) {
        //             Swal.fire({
        //                 title: 'Error!',
        //                 html: 'Position is required',
        //                 icon: 'error',
        //                 confirmButtonColor: '#2db673',
        //             });
        //             return false;
        //         }
        //
        //         $('#loading').show()
        //
        //         const config = {
        //             headers: {
        //                 'content-type': 'multipart/form-data'
        //             },
        //         }
        //
        //         axios.post('http://panglima-storage.test/api/upload', formData, config)
        //             .then(function (response) {
        //                 window.location.href = '/success'
        //             })
        //             .catch(function (error) {
        //
        //                 $('#loading').hide()
        //
        //                 let {position, resume} = error.response.data.message;
        //
        //                 if (resume) {
        //                     Swal.fire({
        //                         title: 'Error!',
        //                         html: resume[0],
        //                         icon: 'error',
        //                         confirmButtonColor: '#2db673',
        //                     });
        //                 } else if (position) {
        //                     Swal.fire({
        //                         title: 'Error!',
        //                         html: position[0],
        //                         icon: 'error',
        //                         confirmButtonColor: '#2db673',
        //                     });
        //                 } else {
        //                     Swal.fire({
        //                         title: 'Error!',
        //                         html: error.response.data.message,
        //                         icon: 'error',
        //                         confirmButtonColor: '#2db673',
        //                     });
        //                 }
        //             });
        //     }
        // })
        // .catch(() => {
        //     Swal.fire({
        //         title: 'Error!',
        //         html: 'Please verify that you are not a robot.',
        //         icon: 'error',
        //         confirmButtonColor: '#2db673',
        //     });
        // });
    })

    function _submitForm()
    {
        let val = $('input[name="position"]:checked').val();
            formData.append('position', val);
            formData.append('g-recaptcha-response', $('#g-recaptcha-response').val())
            if (!val) {
                Swal.fire({
                    title: 'Error!',
                    html: 'Position is required',
                    icon: 'error',
                    confirmButtonColor: '#2db673',
                });
                return false;
            }

            $('#loading').show()

            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                },
            }

            axios.post('https://storage.panglima.org/api/upload', formData, config)
                .then(function (response) {
                    window.location.href = '/success'
                })
                .catch(function (error) {

                    $('#loading').hide()

                    let {position, resume} = error.response.data.message;

                    if (resume) {
                        Swal.fire({
                            title: 'Error!',
                            html: resume[0],
                            icon: 'error',
                            confirmButtonColor: '#2db673',
                        });
                    } else if (position) {
                        Swal.fire({
                            title: 'Error!',
                            html: position[0],
                            icon: 'error',
                            confirmButtonColor: '#2db673',
                        });
                    } else {
                        Swal.fire({
                            title: 'Error!',
                            html: error.response.data.message,
                            icon: 'error',
                            confirmButtonColor: '#2db673',
                        });
                    }
                });
    }

    window._submitForm = _submitForm

}
